<cashdrawer-confirmation (error)="handleValidationResult($event)"></cashdrawer-confirmation>

<header class="header--page">
    <ul class="header__nav">
        <li>
            <h1>Queue Dashboard</h1>
        </li>
        <li>
            <div class="btn-toolbar" role="toolbar">
                <mvm-spinner-btn [isLoading]="" [btnText]="'Refresh'" (clicked)="delegate.loadQueueData()"></mvm-spinner-btn>
            </div>
        </li>
    </ul>
</header>

<div class="mvd_container mvd_form-group">
    <validation-results [validationResults]="delegate.validationResults" *ngIf="delegate.showValidationComponent"></validation-results>
    <p-accordion [multiple]="true" *ngIf="showAccordion" (onOpen)="onTabChange($event)" (onClose)="onTabChange($event)">
        <p-accordionTab header="{{queue.workQueueValue}}" *ngFor="let queue of queueData; let index=index"
            [selected]="buQueueSelected[index]" #BUQueueAccordion>
            <bu-queue *ngIf="showBuQueue" [masterDropdownList]="masterDropdownList" [queue]="queue"
                [user]="delegate.user" (onAssignDropDown)="handleChildAssignmentDropDown($event)"
                (onHold)="holdTransaction($event)"
                (onRemove)="deleteTransaction($event)"
                (onUnassign)="unassignTransaction($event)"
                (onRedirect)="redirectToMyTransaction($event)">
            </bu-queue>
        </p-accordionTab>

        <p-accordionTab header="My Assignments &nbsp; ({{delegate.user.name}})" *ngIf="showPersonalQueue && personalQueueData?.length > 0" [(selected)]="personalQueueSelected"
            #myAssignmentAccordion>
            <my-assignments [masterDropdownList]="masterDropdownList" [personalQueueData]="personalQueueData"
                [user]="delegate.user" (onHold)="holdTransaction($event)"
                (onRemove)="deleteTransaction($event)"
                (onUnassign)="unassignTransaction($event)"
                (onRedirect)="redirectToMyTransaction($event)">
            </my-assignments>
        </p-accordionTab>

        <ng-container *ngIf="showLevelOneQueue">
            <p-accordionTab header="{{levelOne?.workQueueValue}} Escalations" *ngFor="let levelOne of levelOneQueue"
                [(selected)]="businessUnitEscalationsQueueSelected" #myEscalationsLevelOneQueue>
                <escalation-queue-component *ngIf="showEscQueue" [businessTransactionDetails]="levelOne.businessTransactionDetails" [userId]="delegate.userId"
                        [hideEscalateOption]="!levelOne.escalationWorkQueueId"
                        (onNotify)="notifyRequester($event)" (onRespond)="escalationResponse($event)"
                        (onRedirect)="redirectToMyTransaction($event)">
                </escalation-queue-component>
            </p-accordionTab>
        </ng-container>

        <p-accordionTab header="My Escalations" *ngIf="showCsrOverridesQueue"
            [(selected)]="personalEscalationsQueueSelected">
            <my-escalations [csrOverridesQueue]="csrOverridesQueue"></my-escalations>
        </p-accordionTab>
        <customer-request-queue-component></customer-request-queue-component>
    </p-accordion>
</div>